export default class {
  static turboModalTargetPropertyName = 'data-turbo-modal-target';

  constructor({ id, initialContentElement }) {
    this.id = id;
    this.contentParentElement = initialContentElement.parentElement;
    this.initialContentHTML = this._contentHTML(initialContentElement);
  }

  onConnect() {}

  onOpen() {}

  onClose() {}

  // private

  _contentHTML(element) {
    const divElement = document.createElement('div');
    divElement.innerHTML = element.outerHTML;
    divElement.firstChild.removeAttribute(this.constructor.turboModalTargetPropertyName);

    return divElement.innerHTML;
  }
}
